<template>
  <div class="content">
    <el-form :inline="true" :model="searchQuery" class="demo-form-inline" size="small" label-width="100px">
      <!-- <el-form-item label="开始时间">
        <el-date-picker v-model="searchQuery.startTime" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间">
        <el-date-picker v-model="searchQuery.endTime" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item> -->
      <el-form-item label="">
        <el-date-picker v-model="timerange" @change="datechange" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" style="width: 300px"></el-date-picker>
          <el-select v-model="searchQuery.type" placeholder="请选择">
          <el-option label="全部" value="0"></el-option>
          <el-option label="充值" value="1"></el-option>
          <el-option label="订单支付" value="2"></el-option>
          <el-option label="退单" value="3"></el-option>
        </el-select>
        &nbsp;&nbsp;<el-button type="primary" @click="getDataList">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" id="out-table">
      <el-table-column width="180" prop="CreateTime" label="时间" ></el-table-column>
      <el-table-column width="100" label="余额变化(元)" >
        <template slot-scope="scope">
          <span style="margin-left: 10px" >{{(scope.row.Type == 2? (-scope.row.Money):(+ scope.row.Money))}}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="SurplusMoney" label="余额"></el-table-column>
      <el-table-column width="150" prop="Type" label="事由">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{gettype(scope.row.Type)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="160" prop="OrderNo" label="单号"></el-table-column>



    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="searchQuery.index" :total="dataTotal" :page-sizes="[10, 20, 30,500]" :page-size="searchQuery.size">

    </el-pagination>
  </div>

</template>

<script>
  import moment from 'moment'
  import FileSaver from "file-saver";
  import {
    utils,
    write
  } from "xlsx";

  export default {
    name: "orderbill",
    data: function () {
      return {
        dataList: [],
        searchQuery: {
          //   startTime=&endTime=&type=0&index=1&size=20
          startTime: '',
          endTime: '',
          type: "0",
          index: 1,
          size: 10
        },
        timerange: [],
        dataTotal: 0
      }
    },
    created: function () {
      this.getDataList()
    },
    methods: {
      exportExcel() {
        debugger
        /* 从表生成工作簿对象 */
        var wb = utils.table_to_book(document.querySelector("#out-table"));
        /* 获取二进制字符串作为输出 */
        var wbout = write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], {
              type: "application/octet-stream"
            }),
            //设置导出文件名称
            "sheetjs.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
      handleSizeChange(val) {
        this.searchQuery.size = val
        this.getDataList()
      },
      handleCurrentChange(val) {
        this.searchQuery.index = val
        this.getDataList()
      },
      datechange() {
        if (!this.timerange) {
          this.searchQuery.startTime = ""
          this.searchQuery.endTime = ""
        } else {
          //date类型转strin0g
          this.searchQuery.startTime = moment(this.timerange[0]).format('YYYY-MM-DD')
          this.searchQuery.endTime = moment(this.timerange[1]).format('YYYY-MM-DD')
        }

      },
      reset() {
        this.timerange = []
        this.searchQuery = {}
        this.getDataList()
      },
      exportExcel() {

      },
      gettype(value) {
        var type = "";
        switch (value) {
          case 1:
            type = "充值";
            break;
          case 2:
            type = "订单支付";
            break;
          case 3:
            type = "退单";
            break;
          default:
            type = "全部";
            break;
        }
        return type
      },
      getDataList: function () {
        this.$api.GetBillFlowAll(this.searchQuery).then((res) => {
          console.log('%corderbill.vue line:24 flowbill', 'color: #007acc;', res);
          if (res.data.status == 200) {
            var data = res.data.data.data
            var list = [];
            for (var i = 0; i < data.length; i++) {
              for (var j = 0; j < data[i].list.length; j++) {
                list.push(data[i].list[j])
              }

            }
            this.dataTotal = res.data.data.totalPage
            console.log(list)
            this.dataList = list
          }
        })
      }
    }
  }

</script>

<style lang="less" scoped>
  .demo-form-inline {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/page/personcenter/orderbill.vue